document.addEventListener('click', (event) => {
  const tab = event.target.closest('.product-detail-tabs__list label[for]');
  if (!tab) return;

  const input = document.getElementById(tab.htmlFor);
  if (input) input.checked = true;
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter' && event.key !== ' ') return;

  const tab = event.target.closest('.product-detail-tabs__list label[for]');
  if (!tab) return;

  event.preventDefault();
  const input = document.getElementById(tab.htmlFor);
  if (input) input.checked = true;
});
